const freeClassesSlider = () => {

    const slider = $('.js-free-classes-slider');

    if ( slider.length ) {
        slider.slick({
            slidesToShow    : 3,
            variableWidth   : true,
            rows            : 0,
            infinite        : false,
            arrows          : true,
            dots            : false,
            prevArrow       : '<button type="button" class="slick-prev"><svg class="i"><use xlink:href="#stroke-arrow-left"/></svg></button>',
            nextArrow       : '<button type="button" class="slick-next"><svg class="i"><use xlink:href="#stroke-arrow-right"/></svg></button>',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });

    }
}